import React from 'react';

export function Portlet(props) {
  return (
    <div className={`portlet card portlet-list ${props.className || ''}`}>{props.children}</div>
  );
}

export function PortletTitle(props) {
  return (
    <div className={`portlet-title ${props.className || ''}`}>{props.children}</div>
  );
}

export function PortletCaption(props) {
  return (
    <div className={`caption ${props.className || ''}`}>
      {props.children}
      {props.icon && <i className={`fa ${props.icon}`}/>}
      {props.subject && <PortletCaptionSubject>{props.subject}</PortletCaptionSubject>}
    </div>
  );
}

export function PortletCaptionSubject(props) {
  return (
    <span className={`caption-subject ${props.className || ''}`}>{props.children}</span>
  );
}

export function PortletActions(props) {
  return (
    <div className={`actions ${props.className || ''}`}>{props.children}</div>
  );
}

export function PortletBody(props) {
  return (
    <div className={`portlet-body ${props.className || ''}`}>{props.children}</div>
  );
}

export function PortletFooter(props) {
  return (
    <div className={`portlet-footer margin-top-15 ${props.className || ''}`}>{props.children}</div>
  );
}
